export class NumberUtils {

  public static format(
    numberValue: number,
    locale: string,
    options = {},
    roundLongNumber = false,
    roundBillions = true
  ): string {
    const absoluteNumber = Math.abs(numberValue);
    if (roundLongNumber) {
      if (roundBillions && absoluteNumber >= 1.0e+9) {
        return `${ (numberValue / 1.0e+9).toLocaleString(locale, options) }B`;
      }
      if (absoluteNumber >= 1.0e+6) {
        return `${ (numberValue / 1.0e+6).toLocaleString(locale, options) }M`;
      }
    }
    return numberValue.toLocaleString(locale, options);
  }

}
